import SelectBlogModal from "../../../../modals/SelectBlogModal/SelectBlogModal.js";
import CustomErrorWrapper from "./CustomErrorWrapper.js";

const SpecificPageField = ({ input, meta: { error } }) => {

  return (
    <div style={{ paddingLeft: "1.75rem" }}>
      <SelectBlogModal input={input} />
      {error && <CustomErrorWrapper error={error} />}
    </div>
  );
};

export default SpecificPageField;